import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { DefaultDropdown } from '@/component/Dropdown';
import { GuestsDropdown } from '@/component/dropdowns';
import dropdownStyles from '@/component/dropdowns/GuestsDropdown/GuestsDropdown.module.css';

export const GuestsWidget = ({
  guests,
  onIncrement,
  onDecrement,
  pets,
  onTogglePets,
  guestsLimit,
  isPetsAllowed,
}) => {
  const [isGuestsDropdownVisible, setIsGuestsDropdownVisible] = useState(false);

  const guestsCount = guests.adults + guests.infants + guests.children;

  const handleCloseGuestsModal = () => {
    setIsGuestsDropdownVisible(false);
  };

  const guestsRef = useDetectClickOutside({
    onTriggered: handleCloseGuestsModal,
  });

  const t = useTranslations();

  return (
    <div className="max-sm:!hidden sidebar-wrap p-[10px] border-t border-slate-100 focus-within:!bg-white focus-within:rounded-b-10">
      <button
        onClick={() => setIsGuestsDropdownVisible(true)}
        className="bg-transparent flex relative justify-between hover:!bg-slate-100 [&>span>i]:hover:!text-slate-500 rounded-lg w-full p-[9px] cursor-pointer outline-none border-[thin] border-transparent focus:!bg-slate-100 focus:!border-slate-300"
        ref={guestsRef}
        data-testid="guests-dropdown-button"
      >
        <span className="flex gap-x-[10px]">
          <i className="icon-user_alt text-primary-600 text-[24px] leading-none max-md:hidden" />
          <span className="flex flex-col items-start">
            <label className="text-slate-600 text-xs font-medium mt-[-5px] mb-[-2px]">
              {t('guests')}
            </label>
            <span className="text-slate-800 text-sm font-medium mt-[-2px] mb-[-6px]">
              {guestsCount} {guestsCount === 1 ? t('guest') : t('guests')}
            </span>
          </span>
        </span>
        <i className="icon-expand_down text-slate-500 text-[24px] leading-none" />

        {isGuestsDropdownVisible && (
          <DefaultDropdown
            className={`date-range-dropdown-listing-details-guests ${dropdownStyles.dropdown_flex_container}`}
          >
            <GuestsDropdown
              guests={guests}
              pets={pets}
              onIncrement={onIncrement}
              onDecrement={onDecrement}
              onTogglePets={onTogglePets}
              guestsLimit={guestsLimit}
              isPetsAllowed={isPetsAllowed}
            />
          </DefaultDropdown>
        )}
      </button>
    </div>
  );
};
